/** Step 2 "Candidates" incl. blacklist. */
const wizCandEN = {
  wizCandTitle: 'Where do the candidates come from?',
  wizCandSubtitle: 'The SAIA search is usually enough. You can also bring your own search.',
  wizCandMethodSaiaTitle: 'SAIA searches for you',
  wizCandMethodSaiaDesc: 'Recommended. We build the LinkedIn search from your briefing.',
  wizCandMethodUrlTitle: 'Own LinkedIn search',
  wizCandMethodUrlDesc: 'Link to a search from LinkedIn, Sales Navigator or Recruiter.',
  wizCandDerived: 'Derived from your briefing',
  wizCandRederiveHint: 'The job ad has changed – derive the search criteria from the ad again?',
  wizCandRederiveButton: 'Derive again',
  wizCandRederiveBusy: 'Deriving …',
  wizCandRederiveKeep: 'Keep current',
  wizCandRederiveError: 'Deriving failed. Your entries stay unchanged.',
  wizCandAdjust: 'Adjust',
  wizCandAdjustDone: 'Done',
  wizCandLocations: 'Locations',
  wizCandAddLocation: '+ Location',
  wizCandLocationPlaceholder: 'Search a place …',
  wizCandLocationHint: 'Pick places from the LinkedIn place search (city, state or region) · click the radius to change it',
  wizCandLocationHintPlain: 'Pick places from the LinkedIn place search (city, state or region)',
  wizCandCritJobTitles: 'Job title',
  wizCandCritExperience: 'Additional search parameters',
  wizCandCritIndustries: 'Industry',
  wizCandIndustryPlaceholder: 'Search industry …',
  wizCandIndustryNone: 'No matching industry',
  wizCandIndustryMax: 'At most {{count}} industries',
  wizCandIndustryHint: 'Multiple selection as on LinkedIn. SAIA preselects them from the job description – you can add, change and delete.',
  wizCandLocModeCity: 'Place',
  wizCandLocModePostal: 'Postal code + radius',
  wizCandAddPostal: '+ Postal code',
  wizCandPostalPlaceholder: 'Postal code or city …',
  wizCandPostalNone: 'No postal code found at LinkedIn',
  wizCandPostalHint: 'Search a postal code (or city) and pick the LinkedIn entry · click the radius to change it (as in LinkedIn)',
  wizCandRadiusOption: '+ {{km}} km',
  wizCandRadiusNote: 'Your account cannot search by radius: the whole region is always searched. A postal-code radius search needs Sales Navigator or Recruiter.',
  wizCandRadiusNotePostal: '"Place" searches the whole region. Choose "Postal code + radius" for a radius.',
  wizCandRadiusWholeRegion: 'Whole region',
  wizCandRadiusWholeRegionOption: 'Whole region (no radius)',
  wizCandLocationConfirm: '{{city}} – please confirm',
  wizCandLocationConfirmTitle: 'This place has not been confirmed with LinkedIn yet. Click to pick the matching LinkedIn place.',
  wizCandGeoMinChars: 'Type at least two characters',
  wizCandGeoNone: 'No place found at LinkedIn',
  wizCandGeoLoading: 'LinkedIn is searching …',
  wizCandGeoSession: 'The LinkedIn session has expired. Please reconnect the account.',
  wizCandGeoFailed: 'The place search is not available right now. Please try again.',
  wizCandGeoNoAccount: 'Choose a LinkedIn account in step 1 first.',
  wizCandGeoRegionTag: 'Region',
  wizCandCritLanguages: 'Language',
  wizCandAddCriterion: '+ Add',
  wizCandCriterionPlaceholder: 'Entry + Enter',
  wizCandCriteriaEmpty: 'Nothing derived yet',
  wizCandUrlLabel: 'Link to the LinkedIn, Sales Navigator or Recruiter search',
  wizCandUrlPlaceholder: 'https://www.linkedin.com/search/results/people/…',
  wizCandUrlInvalid: 'This is not a LinkedIn link.',
  wizCandUrlsLabel: 'Links to your searches',
  wizCandUrlRowLabel: 'Link {{n}}',
  wizCandUrlRemove: 'Remove link {{n}}',
  wizCandUrlAdd: 'Add another link',
  wizCandUrlMax: 'up to {{count}} links',
  wizCandUrlsTotal_one: 'About {{formatted}} results from {{count}} working link',
  wizCandUrlsTotal_other: 'About {{formatted}} results from {{count}} working links',
  wizCandUrlsWorking_one: '{{count}} link is used',
  wizCandUrlsWorking_other: '{{count}} links are used',
  wizCandUrlsSplit:
    'The first 50 candidates are split across the links (about {{share}} each). Anyone who appears in several searches counts once. Links with an error are skipped at the start.',
  wizCandUrlChecking: 'Checking the link with LinkedIn …',
  wizCandUrlWorks: 'Link works — LinkedIn returns results. The exact number is counted after the start.',
  wizCandUrlWorksCount_one: 'Link works — {{formatted}} result on LinkedIn.',
  wizCandUrlWorksCount_other: 'Link works — {{formatted}} results on LinkedIn.',
  wizCandBlacklistTitle: 'Blacklist',
  wizCandBlacklistDesc:
    'These companies and people are never contacted – no matter whether they come from the SAIA search or your own search.',
  wizCandLists: 'Your blacklists',
  wizCandListsEmpty: 'There is no blacklist yet. Create a new one below.',
  wizCandNewBlacklist: 'Create new blacklist',
  wizCandGlobalListsLoading: 'Loading lists …',
  wizCandGlobalListsError: 'The blacklists could not be loaded.',
  wizCandCountCompanies: 'companies',
  wizCandCountContacts: 'contacts',
  wizCandCountCompany: 'company',
  wizCandCountContact: 'contact',
};
export default wizCandEN;
